import {Typography} from "../../../../components/Wrappers";
import Dot from "../../../../components/Sidebar/components/Dot";
import {ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import Widget from "../../../../components/Widget";
import React from "react";
import { useTheme } from "@material-ui/styles";
import useStyles from "../../styles";
import {DateFormat} from "../../../../helpers/DateFormat";

const ONE_DAY = 24 * 60 * 60000

function bloat(data){
    const {pdu, vdu} = data
    const len = pdu.length
    const out = new Array(len)
    const date = (new Date()).getTime() - pdu.length * ONE_DAY
    for (let i = 0; i < len; ++i){
        out[i] = {
            pdu: pdu[i],
            vdu: vdu[i],
            date: new DateFormat(new Date(date + i * ONE_DAY)).date()
        }
    }
    return out
}


function formatter(value, name){
    return ["%" + value, name === 'pdu' ? "People" : "Vehicles"]
}

export default ({data}) => {
    const theme = useTheme()
    const classes = useStyles(theme)
    return (
        <Widget
            bodyClass={classes.mainChartBody}
            header={
                <div className={classes.mainChartHeader}>
                    <Typography
                        variant="h6"
                        color="text"
                        weight={"medium"}
                        colorBrightness="secondary"
                    >
                        Daily Devices In Use
                    </Typography>
                    <div className={classes.mainChartHeaderLabels}>
                        <div className={classes.mainChartHeaderLabel}>
                            <Dot style={{backgroundColor: theme.series.people}} />
                            <Typography className={classes.mainChartLegentElement}>
                                People
                            </Typography>
                        </div>
                        <div className={classes.mainChartHeaderLabel}>
                            <Dot style={{backgroundColor: theme.series.vehicle}} />
                            <Typography className={classes.mainChartLegentElement}>
                                Vehicles
                            </Typography>
                        </div>
                    </div>
                </div>
            }
        >
            <ResponsiveContainer width="100%" minWidth={200} height={164}>
                <ComposedChart
                    margin={{ top: 15, right: -15, left: -15, bottom: 0 }}
                    data={bloat(data)}
                >
                    <YAxis
                        ticks={[0, 50, 100]}
                        tick={{
                            fill: theme.palette.text.hint + "80",
                            fontSize: 10
                        }}
                        tickFormatter={arg => "%" + arg}
                        stroke={theme.palette.text.hint + "80"}
                        tickLine={false}
                    />
                    <XAxis
                        tickFormatter={i => new DateFormat(i).day()}
                        dataKey="date"
                        tick={{
                            fill: theme.palette.text.hint + "80",
                            fontSize: 10
                        }}
                        stroke={theme.palette.text.hint + "80"}
                        tickLine={false}
                    />
                    <Tooltip />
                    <Line
                        type="monotone"
                        dataKey="pdu"
                        stroke={theme.series.people}
                        strokeWidth={2}
                        dot={false}
                        activeDot={false}
                        formatter={formatter}
                    />
                    <Line
                        type="monotone"
                        dataKey="vdu"
                        stroke={theme.series.vehicle}
                        strokeWidth={2}
                        dot={false}
                        activeDot={false}
                        formatter={formatter}
                    />
                </ComposedChart>
            </ResponsiveContainer>
        </Widget>
    )
}
